import { addOrUpdateItem, removeItem } from '../../helpers';
import * as types from '../../mutation-types';

export default {
    [types.ADD_OR_UPDATE_PROPOSAL]: (state, item) => addOrUpdateItem(state, item),
    [types.SET_PROPOSALS_TOTAL]: (state, total) => state.total = total,
    [types.REMOVE_PROPOSAL]: (state, item) => removeItem(state, item)
}
